import { useState, useMemo, useEffect } from "react";
// import { Image } from "image-js";

export type ResizeOptions = {
  width?: number;
  height?: number;
  preserveAspectRatio?: boolean;
  type?: "image/webp" | "image/jpg" | "image/png" | "image/avif";
};

const defaultOptions: ResizeOptions = {
  preserveAspectRatio: true,
  type: "image/webp",
};

export async function resize(
  file: File,
  options?: ResizeOptions
): Promise<Blob> {
  options ??= defaultOptions;

  // const img = await Image.load(await file.arrayBuffer());

  // const resized = img.resize({
  //   width: options?.width,
  //   height: options?.height,
  //   preserveAspectRatio: true,
  // });
  // return resized.toBlob(options.type, 0.9);
  //
  return await fileToBlob(file);
}

export type UseResizeImageProps = ResizeOptions;

export async function fileToBlob(file: File) {
  return new Blob([new Uint8Array(await file.arrayBuffer())], {
    type: file.type,
  });
}

export const blobToFile = (blob: Blob, name: string, type: string) =>
  new File([blob], name, { type });

export const useResizeImage = (
  f: File | undefined | null | false,
  opts?: UseResizeImageProps
) => {
  const [file, setFile] = useState<File | undefined>();
  const [blob, setBlob] = useState<Blob | undefined>();
  const [url, setUrl] = useState<string | undefined>();

  useEffect(() => {
    (async () => {
      if (!f) {
        setUrl(undefined);
        return;
      }

      const resizedBlob = await resize(f);
      const resizedFile = blobToFile(resizedBlob, f.name, "image/webp");

      setBlob(resizedBlob);
      setUrl(URL.createObjectURL(resizedBlob));
      setFile(resizedFile);
    })();
  }, [f, opts?.height, opts?.width]);

  // WORKS
  // useEffect(() => {
  //   (async () => {
  //     if (!f) {
  //       setUrl(undefined);
  //       return;
  //     }

  //     const resizedBlob = await resize(f);
  //     const resizedFile = blobToFile(resizedBlob, f.name, "image/webp");

  //     setBlob(resizedBlob);
  //     setUrl(URL.createObjectURL(resizedBlob));
  //     setFile(resizedFile);
  //   })();
  //   // NOTE: Passing in opts will cause an infinite loop when using in code
  //   // Therefore we depend on the primitives inside the object instead
  //   // which stabilizes the useEffect
  // }, [f, opts?.width, opts?.height]);

  const result = useMemo(() => {
    return { resizedBlob: blob, resizedFile: file, url: url };
  }, [blob, file, url]);

  return result;
};
